import apiClient from './client';
import type { Produttore, ProduttoreList, TipoSoggetto } from '../types/produttore';

export interface ProduttoriFilters {
  page?: number;
  limit?: number;
  search?: string;
  /** Solo produttori con ≥1 omologa in scadenza entro 30 giorni (deep-link dashboard). */
  omologhe_in_scadenza?: boolean;
}

export interface ProduttoreCreatePayload {
  ragione_sociale: string;
  piva?: string | null;
  codice_fiscale?: string | null;
  email?: string | null;
  telefono?: string | null;
  indirizzo?: string | null;
  citta?: string | null;
  provincia?: string | null;
  cap?: string | null;
  note?: string | null;
  tipo_soggetto?: TipoSoggetto | null;
}

export type ProduttoreUpdatePayload = Partial<ProduttoreCreatePayload>;

export async function listProduttori(filters?: ProduttoriFilters): Promise<ProduttoreList> {
  const params: Record<string, string> = {};
  if (filters?.page != null) params['page'] = String(filters.page);
  if (filters?.limit != null) params['limit'] = String(filters.limit);
  if (filters?.search) params['search'] = filters.search;
  if (filters?.omologhe_in_scadenza) params['omologhe_in_scadenza'] = 'true';
  const { data } = await apiClient.get<ProduttoreList>('/api/produttori', { params });
  return data;
}

export async function getProduttore(id: string): Promise<Produttore> {
  const { data } = await apiClient.get<Produttore>(`/api/produttori/${id}`);
  return data;
}

export async function createProduttore(payload: ProduttoreCreatePayload): Promise<Produttore> {
  const { data } = await apiClient.post<Produttore>('/api/produttori', payload);
  return data;
}

export async function updateProduttore(id: string, payload: ProduttoreUpdatePayload): Promise<Produttore> {
  const { data } = await apiClient.patch<Produttore>(`/api/produttori/${id}`, payload);
  return data;
}

export async function deleteProduttore(id: string): Promise<void> {
  await apiClient.delete(`/api/produttori/${id}`);
}
